import gql from 'graphql-tag';

export const GET_API_VERSION = gql`
    query getApiVersion {
        getApiVersion 
    }
`

